<template>
  <div class="dialog-wrap">
    <el-dialog title="添加科目"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form ref="dataForm"
               :model="dataForm"
               label-width="80px"
               class="userForm"
               style="width:300px">
        <el-form-item label="辅导科目："
                      style="marginTop:10px">
          <el-select v-model="dataForm.extra_tutoring_types"
                     clearable
                     placeholder="请选择"
                     style="width: 300px"
                     @change="handleSubject">
            <el-option v-for="(item, index) in tutorList"
                       :key="index"
                       :label="item.value"
                       :value="item.id">
              <span>{{
                    item.value
                  }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="辅导形式："
                      style="marginTop:10px">
          <el-select v-model="dataForm.extra_service_types"
                     multiple
                     clearable
                     placeholder="请选择"
                     style="width: 300px">
            <el-option v-for="(item, index) in tutorService"
                       :key="index"
                       :label="item.value"
                       :value="item.id">
              <span>{{
                    item.value
                  }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="辅导证明："
                      style="marginTop:10px">
          <el-input v-model="dataForm.extra_tutoring_certify_text"
                    style="width: 300px;marginBottom:10px"
                    :rows="4"
                    type="textarea"
                    placeholder="请输入可以辅导的证明理由，可以上传成绩单或相关证书"></el-input>
          <el-upload :action="imgUploadUrl"
                     :headers="uploadHeaders"
                     list-type="picture-card"
                     :on-preview="handlePictureCardPreview"
                     :on-remove="handleRemove"
                     :on-success="handleSuccess"
                     :file-list="fileList">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

      </el-form>

      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { imgUploadUrl, uploadHeaders } from '@/config/index'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      fileList: [],
      dialogVisible: this.visible,
      dataForm: { extra_service_types: [] },
      tutorList: [
        {
          id: 101,
          value: '政治',
          isFlag: false,
        },
        {
          id: 102,
          value: '英语一',
          isFlag: false,
        },
        {
          id: 103,
          value: '英语二',
          isFlag: false,
        },
        {
          id: 104,
          value: '数学一',
          isFlag: false,
        },
        {
          id: 105,
          value: '数学二',
          isFlag: false,
        },
        {
          id: 106,
          value: '数学三',
          isFlag: false,
        },
        {
          id: 107,
          value: '英语作文批改',
          isFlag: false,
        },
        {
          id: 108,
          value: '199管理类综合',
          isFlag: false,
        },
        {
          id: 109,
          value: '408计算机综合',
          isFlag: false,
        },

        {
          id: 201,
          value: '复试邮件简历',
          isFlag: false,
        },
        {
          id: 202,
          value: '中英文自我介绍',
          isFlag: false,
        },
        {
          id: 203,
          value: '复试口语',
          isFlag: false,
        },
        {
          id: 204,
          value: '综合面试',
          isFlag: false,
        },
        {
          id: 205,
          value: '调剂指导',
          isFlag: false,
        },
        {
          id: 301,
          value: '高等数学',
          isFlag: false,
        },
        {
          id: 302,
          value: '线性代数',
          isFlag: false,
        },
        {
          id: 303,
          value: '概率论与数理统计',
          isFlag: false,
        },
        {
          id: 304,
          value: '大学物理',
          isFlag: false,
        },
        {
          id: 305,
          value: '材料力学',
          isFlag: false,
        },
        {
          id: 306,
          value: '数字电路与模拟电路',
          isFlag: false,
        },
        {
          id: 307,
          value: '理论力学',
          isFlag: false,
        },
        {
          id: 308,
          value: '电工学',
          isFlag: false,
        },
        {
          id: 309,
          value: '运筹学',
          isFlag: false,
        },
        {
          id: 310,
          value: '机械原理',
          isFlag: false,
        },
        {
          id: 311,
          value: '结构力学',
          isFlag: false,
        },
        {
          id: 312,
          value: '自动控制原理',
          isFlag: false,
        },
        {
          id: 313,
          value: '电路',
          isFlag: false,
        },
        {
          id: 401,
          value: '英语四六级',
          isFlag: false,
        },
        {
          id: 402,
          value: '雅思',
          isFlag: false,
        },
        {
          id: 403,
          value: '托福',
          isFlag: false,
        },
        {
          id: 404,
          value: 'GRE',
          isFlag: false,
        },
        {
          id: 405,
          value: '英语专业四级',
          isFlag: false,
        },
        {
          id: 406,
          value: '英语专业八级',
          isFlag: false,
        },
        {
          id: 407,
          value: '计算机二级',
          isFlag: false,
        },
        {
          id: 501,
          value: '教师资格证',
          isFlag: false,
        },
        {
          id: 502,
          value: '法律职业资格（法考）',
          isFlag: false,
        },
        {
          id: 503,
          value: '证券/基金/银行从业资格',
          isFlag: false,
        },
        {
          id: 504,
          value: '初级会计职称',
          isFlag: false,
        },
        {
          id: 505,
          value: '注册会计师（CPA）',
          isFlag: false,
        },
        {
          id: 506,
          value: '导游资格证',
          isFlag: false,
        },
      ],
      tutorService: [
        {
          id: '1',
          value: '1v1辅导（含答疑）',
        },
        {
          id: '2',
          value: '1v1辅导（纯答疑）',
        },
      ],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    handleSubmit() {
      if (this.dataForm.extra_service_types.length == 0) {
        this.$message.error('请选择服务形式')
        return
      }
      this.$nextTick(() => {
        this.tutorList.map((item) => {
          if (item.id == this.dataForm.extra_tutoring_types) {
            this.dataForm.name = item.value
          }
        })
        // console.log('kkkk', this.dataForm.extra_service_types)
        // console.log('3333', this.dataForm)
        this.dataForm.tutoring_certify_img = this.fileList
        this.$emit('chooseList', this.dataForm)
        this.handleClose()
      })
    },
    handleClose() {
      this.fileList = []
      this.dataForm = { extra_service_types: [] }
      this.$emit('close')
    },
    handleSubject(val) {
      console.log('名字', val)
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url
      // this.dialogImageVisible = true
    },
    handleRemove(file, fileList) {},
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url,
      })

      console.log('this.fileList', this.fileList)
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
